module.exports = __webpack_public_path__ + "img/laughEmo.890bac7b.png";